import { EnvironmentTypes } from '../constants/environmentTypes';

const AppDefaultValuesEnum = {
  LANGUAGE: 'en',
  APPLICATION_ID: process.env.REACT_APP_ENV === EnvironmentTypes.Production ? 92 : 139,
};

Object.freeze(AppDefaultValuesEnum);

export { AppDefaultValuesEnum };
